import { Molecule, today } from 'AppReact';
import styled, { css } from 'styled-components';
import { CompletionTime, Title } from './atoms';
import { ReversedProgressBar, Icon, IconFromUrl } from 'atoms';
import { SectionWrapper } from './wrappers';
import { FlexCenterWrapper, GenericWrapper, FlexCenterBetweenWrapper } from 'wrappers';
import { formatDistance, differenceInSeconds, differenceInDays } from 'date-fns';
import { ReopenSvg, ClockSvg, DocumentSvg, LocationSvg, MinusCircleSvg } from 'components/icons';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    height: 62px;
    border-bottom: 1px solid #E7EBEB;
    font-size: 14px;
    font-weight: 400;
    color: ${window?.settings?.secondary_color ?? '#04333b'};
    line-height: 17px;

    cursor: pointer;

    &:hover {
      background-color: ${`${displayState.color}0D`}; 
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: SectionWrapper,
      name: 'TitleSection',
      atoms: [
        {
          component: Icon,
          name: 'Icon',
          displayValue: ({ color }) => DocumentSvg({ color })
        },
        {
          component: Title,
          name: 'Name',
          displayValue: ({ assignment }) => assignment.category
        }
      ]
    },
    {
      wrapper: SectionWrapper,
      name: 'LocationSection',
      atoms: [
        {
          component: IconFromUrl,
          name: 'Image',
          renderIf: ({ assignment }) => !!assignment.property_icon,
          displayValue: ({ assignment }) => assignment.property_icon,
          // displayState: ({}) => ({ width: '30px', height: '30px'})
        },
        {
          component: Icon,
          name: 'Icon',
          renderIf: ({ assignment }) => !assignment.property_icon,
          displayValue: ({ color }) => LocationSvg({ width: "11.33", height: "13.33", color })
        },
        {
          component: Title,
          name: 'Property',
          displayValue: ({ assignment }) => assignment.property
        },
        {
          component: Title,
          name: 'Unit',
          displayValue: ({ assignment }) => assignment.unit ?? '',
          displayState: ({ }) => ({ bold: true })
        }
      ]
    },
    {
      wrapper: GenericWrapper,
      name: 'CompletionTimeOnHold',
      atoms: [
        {
          wrapper: FlexCenterBetweenWrapper,
          name: 'Time',
          atoms: [
            {
              component: CompletionTime,
              renderIf: ({ assignment }) => assignment.status === 'assigned',
              name: 'Submitted',
              displayValue: ({ assignment }) => `${formatDistance(0, differenceInSeconds(new Date(assignment.assigned_at), today()) * 1000, { includeSeconds: true })} ago`,
              displayState: ({ }) => ({ color: '#9EACB0' }),
            },
            {
              component: CompletionTime,
              renderIf: ({ assignment }) => assignment.status === 'assigned',
              name: 'Assigned',
              displayValue: ({ assignment }) => `${formatDistance(0, differenceInSeconds(new Date(assignment.assigned_at), today()) * 1000, { includeSeconds: true })} ago`,
              displayState: ({ color }) => ({ color, margin: '30px' }),
            },
          ]
        },
        {
          component: ReversedProgressBar,
          name: 'ProgressBar',
          renderIf: ({ assignment }) => assignment.status === 'assigned',
          displayValue: ({ }) => '',
          displayState: ({ assignment, color }) => ({
            color,
            reversed: true,
            progress: (differenceInDays(assignment.assigned_at, new Date()) / differenceInDays(new Date(assignment.assigned_at), new Date())) * 100
          })
        }
      ]
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'CompletionTimeSection',
      atoms: [
        {
          component: Icon,
          name: 'Icon',
          renderIf: ({ assignment }) => assignment.status === 'completed',
          displayValue: ({ color }) => ClockSvg({ width: "13.33", height: "13.33", color })
        },
        {
          component: Icon,
          name: 'Icon',
          renderIf: ({ assignment }) => ['callback', 'reopen'].includes(assignment.status),
          displayValue: ({ color }) => ReopenSvg({ color })
        },
        {
          component: Icon,
          name: 'Icon',
          renderIf: ({ assignment }) => assignment.status === 'withdrawn',
          displayValue: ({ color }) => MinusCircleSvg({ width: "13.33", height: "13.33", color: "#FE8363", color })
        },
        {
          component: Title,
          renderIf: ({ assignment }) => assignment.status !== 'assigned',
          name: 'Unit',
          displayValue: ({ assignment }) => {
            let completionTime = '';
            if (assignment.status === 'completed') {
              if (assignment.event_at) {
                completionTime = `Completed Within ${formatDistance(0, differenceInSeconds(new Date(assignment.event_at.split('.')[0] + 'Z'), new Date(assignment.assigned_at)) * 1000, { includeSeconds: true })}`;
              }
            }
            if (['callback', 'reopen'].includes(assignment.status)) {
              completionTime = `Re-opened ${formatDistance(0, differenceInSeconds(today(), new Date(assignment.event_at.split('.')[0] + 'Z')) * 1000, { includeSeconds: true })} ago`;
            }
            if (assignment.status === 'withdrawn') {
              completionTime = `Cancelled ${formatDistance(0, differenceInSeconds(today(), new Date(assignment.event_at.split('.')[0] + 'Z')) * 1000, { includeSeconds: true })} ago`;
            }
            return completionTime;
          },
        }
      ]
    }
  ],
})